export const SELECT_SALES_SUPPORT = "SELECT_SALES_SUPPORT";
export const ADD_SALE_SUPPORT = "ADD_SALE_SUPPORT";
export const CLEAR_SALES_SUPPORT = "CLEAR_SALES_SUPPORT";
export const INIT_SALES_SUPPORT = "INIT_SALES_SUPPORT";
export const EMPTY = "EMPTY";
